import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconInfoInvertedSvg } from "./IconInfoInvertedSvg.mjs";
const IconInfoInverted = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconInfoInvertedSvg, ...iconProps });
};
export {
  IconInfoInverted
};
